import { useUser, useOrganization } from '@clerk/clerk-react'
import { useMemo } from 'react'

export type UserRole = 'provider' | 'gcc' | 'unknown'

interface UseUserRoleResult {
  role: UserRole
  isLoaded: boolean
  organizationId: string | null
}

export function useUserRole(): UseUserRoleResult {
  const { user, isLoaded } = useUser()
  const { organization } = useOrganization()

  const role = useMemo<UserRole>(() => {
    // Read from publicMetadata (set by Clerk webhook)
    const publicRole = (user?.publicMetadata?.role as string | undefined)?.toLowerCase()
    if (publicRole === 'provider' || publicRole === 'gcc') return publicRole

    // Fallback: check unsafeMetadata for backward compatibility
    const unsafeRole = (user?.unsafeMetadata?.role as string | undefined)?.toLowerCase()
    if (unsafeRole === 'provider' || unsafeRole === 'gcc') return unsafeRole

    // Default fallback if no role set
    return 'unknown'
  }, [user])

  return {
    role,
    isLoaded,
    organizationId: organization?.id ?? null
  }
}
